export default __webpack_public_path__ + "static/media/pulper.b861e953.png";